import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Company } from './company.interface';

export const COMPANY_INCLUDES = [
   'activities',
   'addresses',
   'city',
   'customers',
   'employers',
   'jobFunctions',
   'jobFunctions.jobFunctionCategory',
   'legalForm',
   'sectorType',
   'sectorTypeCount',
   'workSchedules',
];

export class CompanyService {
   async getCompanies(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Company>>>(`/companies`, { params: { ...query } });
      return response.data;
   }

   async postCompany(company: Company) {
      const response = await http.post<ApiResource<Company>>(`/companies`, company);
      return response.data;
   }

   async searchCompanyNumber(company_number: number, country_id: number) {
      const response = await http.post(`/companies/company-numbers/search`, { country_id, company_number });
      return response.data;
   }

   async searchCompanyName(company_name: string, country_id: number) {
      const response = await http.post<ApiResource<Array<Company>>>(`/companies/company-numbers/search`, { country_id, company_name });
      return response.data;
   }
}
